var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { serialize, update } from '../../../utils/serializr/serializr';
export class EntitySerialize {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get entity() {
        return this.parent;
    }
    get serialized() {
        return serialize(this.entity);
    }
    set serialized(ser) {
        update(this.entity, ser);
    }
    get serialized_copyFrom() {
        return this.entity.serialized;
    }
    set serialized_copyFrom(ser) {
        update(this.entity, ser, { isCreatingCopy: true });
    }
}
__decorate([
    computed.struct
], EntitySerialize.prototype, "serialized", null);
